"use client";

import { useCallback } from "react";
import { useSession, signOut, signIn } from "../client";
import { useSearchParams } from "next/navigation";

export function useAuth() {
  const q = useSearchParams();
  const { data: session, isPending } = useSession();
  const isLoading = isPending;
  const isAuthenticated = !!session;
  
  const login = useCallback(() => {
    const redirect = q.get("redirect");
    signIn.social({ provider: "google", callbackURL: redirect || "/app" });
  }, []);
  
  const logout = useCallback(async () => {
    try {
      await signOut();
      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error);
      throw error;
    }
  }, []);
  
  return {
    session,
    user: session?.user,
    isLoading,
    isAuthenticated,
    login,
    logout,
  };
} 